// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalInformations_container__2NLOZ","number":"GlobalInformations_number__HeDz6"};